import React from "react";
import "./sudanLanding.scss";
import { useLanguage } from "../i18n/LanguageContext";

const PILLARS = [
   {
      title: "Define — greatest need",
      text: "KAPorg assessments are rooted in community need and organizational context, not externally imposed donor templates."
   },
   {
      title: "Devolve — local leadership",
      text: "The platform empowers Sudanese organizations to lead their own capacity development, building the evidence base for direct funding."
   },
   {
      title: "Deliver — accountability",
      text: "KAPorg tools strengthen financial management, donor compliance, and program monitoring, making Sudanese organizations accountable partners."
   },
   {
      title: "Defend — principles",
      text: "All KAPorg assessments and certifications are aligned with humanitarian principles and internationally recognized compliance standards."
   }
];

const HumanitarianReset = () => {
   const { t } = useLanguage();
   return (
      <section className="sd-section sd-reset" id="humanitarian-reset">
         <div className="container">
            <div className="sd-section-head">
               <span className="sd-eyebrow">{t("Humanitarian Reset")}</span>
               <h2>{t("KAPorg and the IASC Humanitarian Reset")}</h2>
               <p>
                  {t(
                     "The IASC Humanitarian Reset is a global commitment to build a humanitarian system that is faster, lighter, more accountable, and more impactful. KAPorg directly supports its four core pillars."
                  )}
               </p>
            </div>

            <div className="sd-d-grid">
               {PILLARS.map((pillar) => (
                  <div className="sd-d-card" key={pillar.title}>
                     <div className="sd-d-badge">D</div>
                     <h4>{t(pillar.title)}</h4>
                     <p>{t(pillar.text)}</p>
                  </div>
               ))}
            </div>

            <div className="sd-quote">
               <blockquote>
                  {t(
                     "“A humanitarian system that is locally led and globally supported, rooted in communities and driven by greatest need.”"
                  )}
               </blockquote>
               <cite>
                  {t("— IASC Humanitarian Reset Roadmap Vision Statement, November 2025")}
               </cite>
            </div>
         </div>
      </section>
   );
};

export default HumanitarianReset;
